// @ts-nocheck
import React, { useEffect, useState } from "react";
import { LivestreamLayoutCommonProps } from "../../../types";
import { ArrowUp, ArrowDown } from 'react-bootstrap-icons';
import * as Styled from "./Layout2.styled";
import { SeeCard } from "../../media-card/see-card";
import { startVerticalScroll, stopVerticalScroll } from "../../../libs/utils";
import { BigCard } from "../../event-card/big-card";
import { SmallCard } from "../../event-card/small-card";
import { LayoutHeader } from "../../layouts/LayoutHeader";
import LayoutModal from "../../event-card/FullScreenModal";
import { FilterOption } from "../ToggleFilter/ToggleFilter";
import { filterEventsByType } from "../../../libs/utils/eventFilter";
import { EmptyLiveStreams } from "../../empty-state";

export const Layout2: React.FC<LivestreamLayoutCommonProps> = ({
    events,
    sessionToken,
    isSignedIn,
    activePlans,
    hasFullAccess,
    freeTrialPlanIds,
    onWatchClick
}) => {
    const [selectedOption, setSelectedOption] = React.useState<FilterOption>('All');
    const rightScrollRef = React.useRef<HTMLDivElement>(null);
    const scrollIntervalRef = React.useRef<NodeJS.Timeout | null>(null);
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [mainMedia, setMainMedia] = useState<any>(undefined);
    const [selectedCardId, setSelectedCardId] = useState<string | null>(null);

    const handleSeeAllClick = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    useEffect(() => {
        if (events.length && !mainMedia) {
            const firstMedia = events[0];
            setMainMedia(firstMedia);
            setSelectedCardId(firstMedia.id);
        }
    }, [events, mainMedia]);

    const onCardClick = (item: any) => {
        setMainMedia(item);
        setSelectedCardId(item.id);
    };

    const filteredEvents = filterEventsByType(events, selectedOption);
    
    if (!events.length) {
        return <EmptyLiveStreams />;
    }
    
    if (!mainMedia) return null;

    const mainEvent = events[0];

    return (
        <>
            <Styled.FullHeightWrapper>
                <LayoutHeader
                    title={'Live Streams'}
                    itemCount={filteredEvents?.length}
                    selectedOption={selectedOption}
                    setSelectedOption={setSelectedOption}
                    onSeeAll={handleSeeAllClick}
                    padding="20px 10px 20px 0px"
                    marginTop="0px"
                    showToggle={true}
                    isLivestream={true}
                />
                {filteredEvents.length === 0 ? (
                    <EmptyLiveStreams showHeader={false} isFiltered={selectedOption !== 'All'} />
                ) : (
                    <Styled.GridWrapper>
                        <Styled.LeftContainer>
                            <div style={{ position: 'relative' }}>
                                {mainMedia && (
                                    <BigCard
                                        event={mainMedia}
                                        isSignedIn={isSignedIn}
                                        hasEligiblePlan={
                                            isSignedIn &&
                                            (!!mainEvent.planDetails.length
                                                ? !!activePlans.filter((memberPlan) =>
                                                    mainEvent.planDetails.some((plan) => plan?.id === memberPlan.id)
                                                ).length || freeTrialPlanIds.includes(mainEvent.id) || hasFullAccess
                                                : true)
                                        }
                                        onWatchClick={onWatchClick}
                                    />
                                )}
                            </div>
                        </Styled.LeftContainer>

                        <Styled.RightContainer>
                            <Styled.ScrollableList ref={rightScrollRef} scrollable={events.length > 4}>
                                {filteredEvents.map((item, index) => (
                                    <div key={item.id}>
                                        <SmallCard
                                            event={item}
                                            cardClick={() => onCardClick(item)}
                                            isSelected={item.id === selectedCardId}
                                            isSignedIn={isSignedIn}
                                            hasEligiblePlan={
                                                isSignedIn &&
                                                (!!item.planDetails.length
                                                    ? !!activePlans.filter((memberPlan) =>
                                                        item.planDetails.some((plan) => plan?.id === memberPlan.id)
                                                    ).length ||
                                                    freeTrialPlanIds.includes(item.id) ||
                                                    hasFullAccess
                                                    : true)
                                            }
                                            onWatchClick={onWatchClick}
                                        />
                                    </div>
                                )
                                )}
                                {events.length > 6 && (
                                    <div onClick={handleSeeAllClick}>
                                        <SeeCard />
                                    </div>
                                )}
                            </Styled.ScrollableList>

                            {events.length > 3 && (
                                <Styled.ScrollButtonWrapper>
                                    <Styled.ScrollButton
                                        onMouseDown={() => startVerticalScroll(rightScrollRef, 'up', scrollIntervalRef)}
                                        onMouseUp={() => stopVerticalScroll(scrollIntervalRef)}
                                        onMouseLeave={() => stopVerticalScroll(scrollIntervalRef)}
                                        title="Scroll Up"
                                    >
                                        <ArrowUp size={30} />
                                    </Styled.ScrollButton>

                                    <Styled.ScrollButton
                                        onMouseDown={() => startVerticalScroll(rightScrollRef, 'down', scrollIntervalRef)}
                                        onMouseUp={() => stopVerticalScroll(scrollIntervalRef)}
                                        onMouseLeave={() => stopVerticalScroll(scrollIntervalRef)}
                                        title="Scroll Down"
                                    >
                                        <ArrowDown size={30} />
                                    </Styled.ScrollButton>

                                </Styled.ScrollButtonWrapper>
                            )}
                        </Styled.RightContainer>
                    </Styled.GridWrapper>
                )}
            </Styled.FullHeightWrapper>

            <LayoutModal
                show={isModalOpen}
                onHide={handleCloseModal}
                filteredLiveEvents={events}
                isSignedIn={isSignedIn}
                activePlans={activePlans}
                hasFullAccess={hasFullAccess}
                freeTrialPlanIds={freeTrialPlanIds}
                onWatchClick={onWatchClick}
            />
        </>
    );
};
